export const CHARGE_TYPE = {
  MANDATORY_FEE: 'mandatory_fee',
  MANDATORY_TAX: 'mandatory_tax',
  PROPERTY_FEE: 'property_fee',
  RESORT_FEE: 'resort_fee',
  SALES_TAX: 'sales_tax',
  SERVICE_FEE: 'service_fee',
  SERVICE_TAX: 'service_tax',
  TAXES_AND_FEES: 'taxes_and_fees',
};

export const PAYMENT_METHOD = {
  LOYALTY: 'LOYALTY',
  CREDIT_CARD: 'CREDIT_CARD',
  PROMO: 'PROMO',
  DIRECT_DEBIT: 'DIRECT_DEBIT',
  BNPL: 'BNPL',
  DISCOUNT: 'DISCOUNT',
  BIGPAY: 'BIGPAY',
};

export const DISCOUNT_METHOD = {
  CARD_DISCOUNT: 'Payment|Coupon Engine',
  LOB_DISCOUNT: 'Hotel',
};
